import React from 'react';
import { makeStyles, Theme } from '@material-ui/core';

type TabPanelProps = {
    children?: React.ReactNode,
    value?: string,
    index?: string,
    style?: React.CSSProperties,
    flex?: boolean,
};

TabPanel.defaultProps = {
    children: '',
    value: '',
    index: '',
    style: {},
    flex: false,
};

const useStyles = makeStyles((theme: Theme) => ({
    hidden: {
        display: 'none!important',
    },
}));

function TabPanel(props: TabPanelProps): React.ReactElement {
    const {
        children,
        value,
        index,
        style,
        flex,
    } = props;
    const classes = useStyles();

    const displayStyle: React.CSSProperties = flex ? {
        display: 'flex',
        flexDirection: 'column',
    } : {
        display: 'block',
    };

    return (
        <div
            className={value !== index ? classes.hidden : ''}
            role="tabpanel"
            hidden={value !== index}
            style={{
                height: '100%',
                ...displayStyle,
                ...style,
            }}
        >
            {value === index && children}
        </div>
    );
}

export { TabPanel };
